/**
 * Version strings stored on users/{uid} when a provider accepts terms via cold CMR share flow.
 * Bump when ToU / Privacy copy changes materially.
 *
 * BAA body version: see `COLD_PATH_BAA_DOCUMENT_VERSION` in `./coldPathBaa.js`.
 * Legacy field `providerCmrBaaPlaceholderAcceptedAt` may still exist on older accounts.
 */
export const PROVIDER_CMR_TERMS_VERSION = '2026-03-28';
export const PROVIDER_CMR_PRIVACY_VERSION = '2026-03-28';
